import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { compose, withHandlers, lifecycle, withState } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import Typography from '@material-ui/core/Typography';
import { MenuItem, TextField } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import Header from '../../components/Header';
import MenuDrawer from '../../components/MenuDrawer';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import { isAuthenticated, sendLogin } from '../../auth/Auth';
import { getAccounts } from '../../actions/Accounts';
import BatchUserButton from '../../components/atoms/BatchUserButton';
import BatchUserUpdateButton from '../../components/atoms/BatchUserUpdateButton';
import {
  listBatchUser,
  validateBatchUser,
  batchUserImportFile,
  validateBatchUpdateUser,
  batchUserImportUpdateFile,
  GET_BATCH_USER_SUCCESS,
  VALIDATE_BATCH_USER_SUCCESS,
  ADD_BATCH_USER_IMPORT_FILE_SUCCESS
} from '../../actions/Users';
import '../../stylesheets/csv.css';
import SearchButton from '../../components/atoms/SearchButton';
import BatchUserTable from '../organisms/BatchUserTable';
import batchUserStatuses from '../../constants/BatchUserStatuses';
import batchUserTypeProcess from '../../constants/BatchUserTypeProcess';

const styles = theme => ({
  root: {
    backgroundColor: '#e0e0e0',
    flexGrow: 1,
    width: '100%'
  },
  pageTitileDiv: {
    paddingLeft: 20,
    paddingTop: 2,
    textAlign: 'left',
    backgroundColor: '#fff'
  },
  pageDiscriptionDiv: {
    paddingLeft: 26,
    paddingTop: 2,
    textAlign: 'left'
  },
  mainPaper: {
    position: 'relative',
    margin: 20
  },
  zoom: {
    position: 'relative',
    left: -10,
    top: 20
  },
  mainPaperTitleDiv: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '20px 26px 10px 26px'
  },
  searchForm: {
    padding: '10px 26px 10px 26px',
    maxWidth: 700
  },
  textField: {
    padding: '0px 5px 0px 5px',
    width: '300px'
  },
  buttonGroupLeft: {
    textAlign: 'left'
    // float: 'left'
  },
  buttonRight: {
    textAlign: 'right'
  },
  buttonGroupRight: {
    textAlign: 'right'
  },
  textInput100: {
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  flex: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  inputContainer: {
    padding: 30,
    display: 'flex',
    flexDirection: 'column-reverse'
  },
  flexColumnRevert: {
    display: 'flex',
    flexDirection: 'column-reverse'
  },
  flexRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  searchFormContainer: {
    backgroundColor: '#fff',
    margin: 15
  },
  buttonRegis: {
    width: '100%'
  },
  inputRegis: {
    marginLeft: 6,
    marginBottom: 10,
    marginTop: 10
  },
  textAlignLeft: {
    textAlign: 'left'
  },
  description: {
    padding: '10px 26px 10px 26px'
  }
});

const enhance = compose(
  connect(
    state => ({
      account: state.accounts.account
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          getAccounts,
          listBatchUser,
          validateBatchUser,
          batchUserImportFile,
          validateBatchUpdateUser,
          batchUserImportUpdateFile
        },
        dispatch
      )
    })
  ),
  withState('file', 'setFile', null),
  withState('resultMessage', 'setResultMessage', ''),
  withState('openDrawer', 'updateOpenDrawer', false),
  withState('loading', 'updateLoading', false),
  withState('openProgress', 'updateOpenProgress', false),
  withState('isAddSuccess', 'updateIsAddSuccess', false),
  withState('userName', 'setUserName', null),
  withState('gochiUserId', 'setGochiUserId', null),
  withState('userId', 'setUserId', null),
  withState('createdAt', 'setCreatedAt', null),
  withState('status', 'setStatus', ''),
  withState('typeProcess', 'setTypeProcess', null),
  withState('page', 'setPage', 1),
  withState('openTable', 'updateOpenTable', true),
  withState('rowsPerPage', 'setRowsPerPage', 100),
  withState('openConfirm', 'updateOpenConfirm', false),
  withState('openUpdateConfirm', 'updateOpenUpdateConfirm', false),
  withState('validateData', 'setValidateData', {}),
  withState('validateUpdateData', 'setValidateUpdateData', {}),
  withHandlers({
    checkSession: props => data => {
      console.log(data);
      if (
        data.error === true &&
        typeof data.payload !== 'undefined' &&
        data.payload.status === 403
      ) {
        sendLogin(props);
      }
      return data;
    }
  }),
  withHandlers({
    handleRedirect: props => path => {
      props.history.push(path);
    },
    handleChangePage: props => (event, page, limit) => {
      const limitNum = limit || props.rowsPerPage;
      console.log('HANDLE CHANGE PAGE');
      const table = document.getElementById('scrollTableId');
      if (table !== null) {
        table.scrollTop = 0;
      }
      props.setPage(page);

      const searchKey = {
        userName: props.userName,
        userId: props.userId,
        createdAt: props.createdAt,
        status: props.status,
        typeProcess: props.typeProcess,
        page,
        limit: limitNum
      };

      props.updateLoading(true);
      // props.updateOpenProgress(true);
      props.actions.listBatchUser(searchKey).then(data => {
        props.checkSession(data);
        if (data.type === GET_BATCH_USER_SUCCESS) {
          props.updateOpenProgress(false);
          props.setResultMessage('');
          props.updateLoading(false);
          props.updateOpenTable(true);
        } else {
          props.setResultMessage('エラーが発生しました！');
          props.updateLoading(false);
        }
      });
    }
  }),
  lifecycle({
    componentDidMount() {
      isAuthenticated(this.props);
      this.props.actions.getAccounts({ cognitoUserId: '' }).then(async data => {
        this.props.checkSession(data);
        this.props.handleChangePage(null, 1, this.props.rowsPerPage);
      });
    }
  })
);

const Main = enhance(
  ({
    actions,
    account,
    classes,
    file,
    setFile,
    resultMessage,
    setResultMessage,
    checkSession,
    openDrawer,
    updateOpenDrawer,
    openProgress,
    openTable,
    updateOpenTable,
    updateOpenProgress,
    loading,
    updateLoading,
    userId,
    setUserId,
    createdAt,
    setCreatedAt,
    status,
    setStatus,
    typeProcess,
    setTypeProcess,
    handleChangePage,
    page,
    rowsPerPage,
    setRowsPerPage,
    openConfirm,
    updateOpenConfirm,
    validateData,
    setValidateData,
    openUpdateConfirm,
    updateOpenUpdateConfirm,
    validateUpdateData,
    setValidateUpdateData
  }) => {
    const progress = {
      loading,
      updateLoading,
      openProgress,
      updateOpenProgress,
      setResultMessage
    };

    const searchAction = async () => {
      updateOpenTable(true);
      handleChangePage(null, 1, rowsPerPage);
    };

    const progressOkAction = () => {
      updateOpenProgress(false);
      updateLoading(true);
      handleChangePage(null, page, rowsPerPage);
    };

    const validateAction = async () => {
      updateLoading(true);
      updateOpenProgress(true);
      const formData = new FormData();
      if (file) {
        formData.append('file', file, file.name);
        console.log(file);
        const uploadedFile = await actions
          .validateBatchUser(formData)
          .then(data => checkSession(data));

        if (uploadedFile.type === VALIDATE_BATCH_USER_SUCCESS) {
          setValidateData(uploadedFile.payload);
          updateOpenConfirm(true);
          updateLoading(false);
        } else {
          setResultMessage('エラーが発生しました！');
          updateLoading(false);
        }
      } else {
        setResultMessage('ファイルが選択されていません。');
        updateLoading(false);
      }
      updateOpenProgress(false);
    };

    const registerAction = async () => {
      updateLoading(true);
      updateOpenProgress(true);
      console.log('registerAction');
      const formData = new FormData();
      if (file) {
        formData.append('file', file, file.name);
        console.log(file);
        const uploadedFile = await actions
          .batchUserImportFile(formData)
          .then(data => checkSession(data));

        if (uploadedFile.type === ADD_BATCH_USER_IMPORT_FILE_SUCCESS) {
          if (uploadedFile.payload.code === 200) {
            setResultMessage('データをインポートしました');
          } else {
            setResultMessage(
              'データのインポートに失敗しました。もう一度やり直してください'
            );
          }
          updateLoading(false);
          updateOpenConfirm(false);
        } else {
          setResultMessage(
            'データのインポートに失敗しました。もう一度やり直してください'
          );
          updateLoading(false);
          updateOpenConfirm(false);
        }
      } else {
        setResultMessage('ファイルが選択されていません。');
        updateLoading(false);
      }
    };

    const validateUpdateAction = async () => {
      updateLoading(true);
      updateOpenProgress(true);
      const formData = new FormData();
      if (file) {
        formData.append('file', file, file.name);
        console.log(file);
        const uploadedFile = await actions
          .validateBatchUpdateUser(formData)
          .then(data => checkSession(data));

        if (uploadedFile.type === VALIDATE_BATCH_USER_SUCCESS) {
          setValidateUpdateData(uploadedFile.payload);
          updateOpenUpdateConfirm(true);
          updateLoading(false);
        } else {
          setResultMessage('エラーが発生しました！');
          updateLoading(false);
        }
      } else {
        setResultMessage('ファイルが選択されていません。');
        updateLoading(false);
      }
      updateOpenProgress(false);
    };

    const updateAction = async () => {
      updateLoading(true);
      updateOpenProgress(true);
      console.log('updateAction');
      const formData = new FormData();
      if (file) {
        formData.append('file', file, file.name);
        console.log(file);
        const uploadedFile = await actions
          .batchUserImportUpdateFile(formData)
          .then(data => checkSession(data));

        if (uploadedFile.type === ADD_BATCH_USER_IMPORT_FILE_SUCCESS) {
          if (uploadedFile.payload.code === 200) {
            setResultMessage('データをインポートしました');
          } else {
            setResultMessage(
              'データのインポートに失敗しました。もう一度やり直してください'
            );
          }
          updateLoading(false);
          updateOpenUpdateConfirm(false);
        } else {
          setResultMessage(
            'データのインポートに失敗しました。もう一度やり直してください'
          );
          updateLoading(false);
          updateOpenUpdateConfirm(false);
        }
      } else {
        setResultMessage('ファイルが選択されていません。');
        updateLoading(false);
      }
    };

    return (
      <div className={classes.root}>
        <Header
          onMenuClick={() => {
            updateOpenDrawer(true);
          }}
        />
        <Drawer
          open={openDrawer}
          anchor="left"
          onClose={() => {
            updateOpenDrawer(false);
          }}
        >
          <div tabIndex={0} role="button">
            <MenuDrawer account={account} />
          </div>
        </Drawer>
        <div className={classes.pageTitileDiv}>
          <Typography variant="h6" color="textSecondary">
            ユーザ一括登録
          </Typography>
        </div>
        <Paper className={classes.mainPaper} elevation={1}>
          <div className={classes.searchFormContainer}>
            <div className={classes.flex}>
              <div className={classes.searchForm}>
                <TextField
                  label="ユーザID"
                  type="search"
                  className={classes.textField}
                  margin="normal"
                  value={userId}
                  onChange={e => {
                    setUserId(e.target.value);
                  }}
                />
                <TextField
                  label="インポート日"
                  type="date"
                  className={classes.textField}
                  margin="normal"
                  value={createdAt}
                  onChange={e => {
                    setCreatedAt(e.target.value);
                  }}
                  InputLabelProps={{
                    shrink: true
                  }}
                />
                <TextField
                  select
                  label="ステータス"
                  className={classes.textField}
                  margin="normal"
                  value={status}
                  onChange={e => {
                    setStatus(e.target.value);
                  }}
                >
                  {batchUserStatuses.map(item => {
                    return (
                      <MenuItem key={item.id} value={item.value}>
                        {item.name}
                      </MenuItem>
                    );
                  })}
                </TextField>
                <TextField
                  select
                  label="処理内容"
                  className={classes.textField}
                  margin="normal"
                  value={typeProcess}
                  onChange={e => {
                    setTypeProcess(e.target.value);
                  }}
                >
                  {batchUserTypeProcess.map(item => {
                    return (
                      <MenuItem key={item.id} value={item.value}>
                        {item.name}
                      </MenuItem>
                    );
                  })}
                </TextField>
                <div className={classes.buttonGroupLeft}>
                  <SearchButton onClickAction={searchAction} />
                </div>
              </div>
              <div className={`${classes.flex} ${classes.inputContainer}`}>
                <a
                  href="https://d2mdjfflfn266g.cloudfront.net/public/files/batch_user_change_email_sample_file.xlsx"
                  download="batch_user_change_email_sample_file.xlsx"
                  // eslint-disable-next-line react/jsx-no-target-blank
                  target="_blank"
                >
                  EXCELフォーマットダウンロード_メールアドレス変更
                </a>
                <a
                  href="https://d2mdjfflfn266g.cloudfront.net/public/files/batch_user_register_sample_file.xlsx"
                  download="batch_user_register_sample_file.xlsx"
                  // eslint-disable-next-line react/jsx-no-target-blank
                  target="_blank"
                >
                  EXCELフォーマットダウンロード_一括登録
                </a>
                <div className={classes.textAlignLeft}>
                  <input
                    type="file"
                    onChange={e => {
                      setFile(e.target.files[0]);
                    }}
                    className={classes.inputRegis}
                    onClick={e => {
                      e.target.value = '';
                    }}
                  />
                  <div className={classes.buttonRegis}>
                    <BatchUserButton
                      onClickAction={validateAction}
                      registerAction={registerAction}
                      name="ユーザ一括登録"
                      validateData={validateData}
                      openConfirm={openConfirm}
                      updateOpenConfirm={updateOpenConfirm}
                      classes={classes}
                    />
                    <BatchUserUpdateButton
                      onClickAction={validateUpdateAction}
                      updateAction={updateAction}
                      name="メールアドレス更新"
                      validateData={validateUpdateData}
                      openConfirm={openUpdateConfirm}
                      updateOpenConfirm={updateOpenUpdateConfirm}
                      classes={classes}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className={classes.description}>
              ※ユーザ一括登録ジョブの仕様
              <br />
              ・1分に1回実行して、毎回100件を処理する
              <br />
              ※1回でアップロードできるのは1000件まで
            </div>
          </div>
          {openTable && (
            <BatchUserTable
              page={page}
              handleChangePage={handleChangePage}
              progress={progress}
              rowsPerPage={rowsPerPage}
              setRowsPerPage={setRowsPerPage}
              setResultMessage={setResultMessage}
              updateOpenProgress={updateOpenProgress}
              updateLoading={updateLoading}
            />
          )}
        </Paper>

        <ProgressDialog
          openProgress={openProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={resultMessage}
        />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
